@if (visible) {
  <div class="twopager-save-dialog__backdrop" (click)="onCancel()"></div>
  <div
    class="twopager-save-dialog__card"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
  >
    <div class="twopager-save-dialog__modal-head">
      <div
        [id]="titleId"
        class="twopager-save-dialog__modal-title"
      >
        {{ titleKey | translate }}
      </div>
      <button
        class="twopager-save-dialog__modal-x"
        type="button"
        [attr.aria-label]="'general.close' | translate"
        (click)="onCancel()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="twopager-save-dialog__modal-body">
      <p class="twopager-save-dialog__modal-text">
        {{ textKey | translate: { name: conflictingName } }}
      </p>

      <mat-radio-group
        class="twopager-save-dialog__options"
        [(ngModel)]="mode"
        name="saveConflictMode"
      >
        <mat-radio-button value="update">{{
          updateKey | translate
        }}</mat-radio-button>
        <mat-radio-button value="saveAs">{{
          'export.template.exists.saveAs' | translate
        }}</mat-radio-button>
        @if (isLoadedTemplate) {
          <mat-radio-button value="skip">{{
            skipKey | translate
          }}</mat-radio-button>
        }
      </mat-radio-group>

      @if (mode === 'saveAs') {
        <label class="twopager-save-dialog__field-label" [for]="nameFieldId">{{
          'consultant.export.modal.nameLabel' | translate
        }}</label>
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="twopager-save-dialog__name-field"
        >
          <input
            matInput
            [id]="nameFieldId"
            [(ngModel)]="newName"
            name="newTemplateName"
            [maxlength]="LIMITS.EXPORT_CONFIG_NAME"
            (ngModelChange)="nameTouched = true"
            (blur)="nameTouched = true"
          />
        </mat-form-field>
        @if (displayedNameErrorKey) {
          <small class="twopager-save-dialog__error">{{
            displayedNameErrorKey
              | translate: { max: LIMITS.EXPORT_CONFIG_NAME }
          }}</small>
        }
      }
    </div>

    <div class="twopager-save-dialog__modal-foot">
      <div class="twopager-save-dialog__modal-actions">
        <button
          type="button"
          class="twopager-save-dialog__btn-text twopager-save-dialog__cancel"
          (click)="onCancel()"
        >
          {{ 'general.cancel' | translate }}
        </button>
        <button
          type="button"
          class="twopager-save-dialog__btn-primary twopager-save-dialog__submit"
          [disabled]="!canSubmit"
          (click)="onSubmit()"
        >
          {{ saveText | translate }}
        </button>
      </div>
    </div>
  </div>
}
